<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom et Prénom</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Adresse email</span>
      </div>
      <input disabled type="email" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Téléphones</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="pays">Pays</label>
      </div>
      <select disabled class="custom-select" id="pays">
        <option>Choose...</option>
        <option selected value="1">République Démocratique du Congo</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="ville">Ville</label>
      </div>
      <select disabled class="custom-select" id="ville">
        <option>Choose...</option>
        <option selected value="1">Kinshasa</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Commune</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Quartier</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Avenue et Numéro</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Code postal</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date d'inscription</span>
      </div>
      <input disabled type="date" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Dernière date de connexion</span>
      </div>
      <input disabled type="date" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="etat_activite">Etat d'activité</label>
      </div>
      <select disabled class="custom-select" id="etat_activite">
        <option>Choose...</option>
        <option selected value="1">Actif</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm mb-3 d-flex flex-row">
      <div class="">
        <span class="customized-span">Sexe</span>
      </div>
      <div class="ml-3">
        <div class="custom-control custom-radio custom-control-inline">
          <input checked disabled type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input">
          <label class="custom-control-label" for="customRadioInline1">Homme</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input disabled type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input">
          <label class="custom-control-label" for="customRadioInline2">Femme</label>
        </div>
      </div>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date de naissance</span>
      </div>
      <input disabled type="date" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="lieu_naissance">Lieu de naissance</label>
      </div>
      <select disabled class="custom-select" id="lieu_naissance">
        <option>Choose...</option>
        <option selected value="1">Lubumbashi</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="nationalite">Nationalité</label>
      </div>
      <select disabled class="custom-select" id="nationalite">
        <option>Choose...</option>
        <option selected value="1">République Démocratique du Congo</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm mb-3 d-flex flex-row">
      <div class="align-self-center">
        <span class="customized-span">Avatar</span>
      </div>
      <div class="align-self-center ml-3">
        <img title="" alt="" class="img-fluid w-40" src="../../../assets/img/logo-2.png">
      </div>
    </div>
    <div class="input-group-sm mb-3 d-flex flex-row">
      <div class="align-self-center">
        <span class="customized-span">Type d'enregistrement</span>
      </div>
      <div class="align-self-center ml-3">
        <font-awesome-icon size="2x" :icon="['fab', 'facebook']"></font-awesome-icon>
      </div>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Acheteur depuis</span>
      </div>
      <input disabled type="date" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Compte modifié le</span>
      </div>
      <input disabled type="date" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm mb-3 d-flex flex-row">
      <p class="font-weight-bold text-nowrap">Note : </p>
      <p class="align-self-center ml-3">
        Ce compte a été supprimé parce que l'utilisateur ne respectais pas les règles de la cmpagnie
      </p>
    </div>
  </form>
</template>

<script>
export default {
  name: "Read"
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/acheteurs/components/Read.vue